import { render, staticRenderFns } from "./JewelCoords.vue?vue&type=template&id=05014f93&scoped=true&"
import script from "./JewelCoords.vue?vue&type=script&lang=js&"
export * from "./JewelCoords.vue?vue&type=script&lang=js&"
import style0 from "./JewelCoords.vue?vue&type=style&index=0&id=05014f93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05014f93",
  null
  
)

export default component.exports